import { render, staticRenderFns } from "./PreferencesFormations.vue?vue&type=template&id=59911432"
import script from "./PreferencesFormations.vue?vue&type=script&lang=js"
export * from "./PreferencesFormations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports